import(/* webpackMode: "eager", webpackExports: ["CurrencyDetailClient"] */ "/app/app/(finance)/finance/components/CurrencyDetailClient.tsx");
